export function setLoading(state, loading) {
    state.loading = loading
}
export function setContacts(state, contacts) {
    state.contacts = contacts;
}
export function setCheckState(state, check_states) {
    state.check_states = check_states;
}
export function setDefaultStateCheck (state) {
    let default_item =  state.check_states.find(el => el.code_parameter === '1');
    default_item ?  state.params.state_check_id = default_item.id : null
}
export function setReportDataConsigned(state, data) {
    state.data = data;
}
export function setAuxiliaryAccounts(state, data) {
    state.auxiliary_accounts = data;
}
export function setConsecutive(state,consecutive){
    let consecutive_number = consecutive.consecutive_number+1
    state.payload.num_doc = consecutive_number.toString()
    state.payload.prefix = consecutive.prefix
}
export function setDefaultVoucher(state,data){
    let default_v  = data.find(ele => ele.code_voucher_type === '312')
    state.payload.voucherType_id = default_v?default_v.id : null
}
export function setDataVoucherTransaction(state,data){
    if (data.debit_credit === 'C'){
        state.payload.total_credit = data.value
    }else{
        state.payload.total_debit = data.value
    }
    state.payload.document_transaction = data
}
export function updateVoucherPayload(state,document_transaction){


    let transaction = document_transaction;
    transaction.id_document_transactions = document_transaction.id
    transaction.value = document_transaction.operation_value
    transaction.debit_credit = document_transaction.transactions_type
    transaction.observation = document_transaction.observations

    state.payload.document_id = document_transaction.document_id
    state.payload.document_transactions.push(transaction)
}
export function setFinalizeVoucher(state,data){
    state.show_pdf  = true
    state.file_name = data.accounting_link
}
export function clearParamsModalTransaction(state,data){
    state.show_pdf  = false
    state.file_name = ''
    state.payload = {
        branchoffice_id: state.payload.branchoffice_id,
        voucherType_id:  state.payload.voucherType_id,
        num_doc: null,
        prefix: null,
        date: state.payload.date,
        id:null,
        contact_id: null,
        city_id: null,
        document_id: null,
        user_id: null,
        document_transaction: {
            id: null,
            account_id: null,
            affects_document_id: null,
            observation: "Consignación cheques",
            contact_id: 0,
            no_doc: null,
            value: 0,
            base_value: 0,
            order: 1,
            projects_column_visible: 0,
            contact_column_visible: true,
            cost_center_column_visible: false,
            base_value_column_visible: false,
            manage_document: false,
            validation_no_doc: null,
            account_code: "",
            account_name: "",
            tax_id: null,
            payment_column_visible: false,
            manage_bank_document: false,
            commissionable_concept: false,
            debit_credit: null,
            id_document_transactions: null
        },
        document_transactions: [],
        total_debit: null,
        total_credit: null,
        ids_conciliation:[],
        update_document_payments_methods:[]
    }
}
export function setUpdateDocumentpp(state,data){
    alert('qqqq')
    state.payload.update_document_payments_methods = data.map(i => i.data.id)
}
export function setConsignedData(state,data){
    state.payload.update_document_payments_methods.push(data)
}
export function setConsigned(state,bool){
    state.pending_consigned = bool
    state.payload.document_transaction.observation = bool ?'Consignación cheques':'Devolución cheque'
}
export function setDocumentPaymentUpdate(state){

    let transactionDebit = state.payload.document_transactions.find(el => el.transactions_type === 'D');

    state.payload.update_document_payments_methods.forEach((item) => {
        item.document_transaction_id = transactionDebit.id;
        item.account_id = transactionDebit.account_id;
    });


}



// WEBPACK FOOTER //
// ./src/modules/check-consignment/mutations.js